const axios = require('axios');

module.exports.getConfigFromContext = (scriptFullPath, windowLocation) => {
    let pageUrl = `${windowLocation.protocol}//${window.location.host}${window.location.pathname}${window.location.search}`;
    let baseUrl = '/api/initiate?';
    let pageUrlParam = `pageUrl=${pageUrl}`;
    let hostPath = scriptFullPath.split('?')[0];
    let hostPathParam = `hostPath=${hostPath}`;
    let scriptParams = scriptFullPath.split('?')[1];

    let ifhelpBaseUrl = hostPath.substr(0, hostPath.lastIndexOf('/'));
    //CHECK FOR OVERRIDE OF CONFIG QUERY
    let configOverride = '';
    if (typeof URL === 'function') {
        let params = new URL(document.location).searchParams;
        if (params && params.get('ifhelpconfig'))
            configOverride = `&ifhelpconfig=${params.get('ifhelpconfig')}`;
    }

    let url = scriptParams
        ? `${ifhelpBaseUrl}${baseUrl}${pageUrlParam}&${hostPathParam}&${scriptParams}${configOverride}`
        : `${ifhelpBaseUrl}${baseUrl}${pageUrlParam}&${hostPathParam}${configOverride}`;

    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url,
        })
            .then((res) => resolve(res.data))
            .catch((error) => reject(error.response.data));
    });
};
